import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { CategoryType } from "../../../../graphql/types"

export type SchematizedTileComponentItem = {
    id: Maybe<string>
    x: Maybe<number>
    y: Maybe<number>
    name: Maybe<string>
    color: Maybe<string>
    icon: Maybe<number>
    type: Maybe<CategoryType>
    price: Maybe<string>
    categoryId: Maybe<string>
    gridId: Maybe<string>
    linkedGridId: Maybe<string>
    targetPageGroupId: Maybe<string>
    isBackButton: boolean
    isSticky: boolean
    isActive?: boolean
    parentId?: Maybe<string>
    count?: number
    tileImageUrl?: Maybe<string>
}

export type StickyType = (typeof StickyTypeEnum)[keyof typeof StickyTypeEnum]

export const StickyTypeEnum = {
    Root: "root",
    Current: "current",
}
